// Access levels: 0 none · 1 view · 2 comment · 3 tick · 4 edit · 5 admin
export const LEVELS = ['None', 'View', 'Comment', 'Tick', 'Edit', 'Admin'] as const;

export type Access = {
  user_id: string;
  super_admin: boolean;
  roles: { role: string; site_id: string | null; project_id: string | null }[];
  grants: { module: string; site_id: string | null; level: number }[];
};

export function levelOf(access: Access | null, module: string, siteId: string | null): number {
  if (!access) return 0;
  if (access.super_admin) return 5;
  let best = 0;
  for (const g of access.grants) {
    if (g.module !== module) continue;
    if (siteId && g.site_id && g.site_id !== siteId) continue;
    if (g.level > best) best = g.level;
  }
  return best;
}

export type ModuleDef = { key: string; label: string; path: string; version: string };

// Order = side menu order. `version` = when it arrives; built ones have a path.
export const MODULES: ModuleDef[] = [
  { key: 'action_centre', label: 'Action Centre', path: '/', version: '0.1' },
  { key: 'buildings', label: 'Buildings & projects', path: '/buildings', version: '0.1' },
  { key: 'claims', label: 'Claims', path: '/r/claims', version: '0.2' },
  { key: 'variations', label: 'Variations', path: '/r/variations', version: '0.2' },
  { key: 'costs', label: 'Barge & costs', path: '', version: '0.6' },
  { key: 'rfis', label: 'RFIs & site instructions', path: '/r/rfis', version: '0.2' },
  { key: 'notices', label: 'Notices (NOPD/GC/DT/EOT)', path: '/r/notices', version: '0.2' },
  { key: 'ndas', label: 'NDAs', path: '/r/ndas', version: '0.2' },
  { key: 'requests', label: 'Requests & follow-ups', path: '', version: '0.5' },
  { key: 'defects', label: 'Defects', path: '', version: '0.4' },
  { key: 'inspections', label: 'Inspections', path: '', version: '0.4' },
  { key: 'documents', label: 'Drawings & documents', path: '', version: '0.3' },
  { key: 'weekly_reports', label: 'Contractor weekly reports', path: '', version: '0.3' },
  { key: 'progress', label: 'Progress journal', path: '', version: '0.4' },
  { key: 'handover', label: 'Handover & close-out', path: '', version: '0.4' },
  { key: 'finishes', label: 'Finishes & items', path: '', version: '0.7' },
  { key: 'maintenance', label: 'Maintenance', path: '', version: '0.11' },
  { key: 'daily_log', label: 'Daily site log', path: '', version: '0.4' },
  { key: 'contracts', label: 'Contracts', path: '/contracts', version: '0.1' },
  { key: 'orgs', label: 'Organisations & contacts', path: '/orgs', version: '0.1' },
  { key: 'files', label: 'Files', path: '/files', version: '0.1' },
  { key: 'reports', label: 'Reports & exports', path: '', version: '0.5' },
  { key: 'assistant', label: 'Ask Claude', path: '', version: '0.9' },
  { key: 'admin', label: 'Admin & audit log', path: '/admin', version: '0.1' },
];
